var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count)?_c('v-avatar',{staticClass:"notifications-count-badge",attrs:{"color":"error","size":19}},[_c('span',{staticClass:"light--text"},[_vm._v(_vm._s(_vm.count))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }